    <template>
    <div class="page-container">
        <IntroSection/>
        <KeyAdvantagesSection/>
        <FeaturesAndFunctionsSection/>
        <ContentFeaturesSection/>
        <ManageAdvantagesSection />
        <FaqAndContactSection />
    </div>
</template>

<script>
    import IntroSection from "./sections/IntroSection";
    import KeyAdvantagesSection from "./sections/KeyAdvantagesSection";
    import FeaturesAndFunctionsSection from "./sections/FeaturesAndFunctionsSection";
    import ContentFeaturesSection from "./sections/ContentFeaturesSection";
    import ManageAdvantagesSection from "./sections/ManageAdvantagesSection";
    import FaqAndContactSection from "./sections/FaqAndContactSection";

    export default {
        name: "MainPage",
        components: {
            FaqAndContactSection,
            ManageAdvantagesSection,
            ContentFeaturesSection,
            FeaturesAndFunctionsSection,
            KeyAdvantagesSection,
            IntroSection
        }
    }
</script>

<style scoped lang="scss">
    @import "../../theme/theme";

    /* Page common*/
    .page-container {
        display: grid;
        grid-auto-flow: row;
        grid-gap: 1em;
    }
</style>